import React from "react";
import { Spinner } from "react-bootstrap";
import styled from "styled-components";

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column; /* Stack items vertically */
  justify-content: center;
  align-items: center;
  z-index: 9999;
  color: white; /* Text color */
`;

const StyledSpinner = styled(Spinner)`
  width: 3rem;
  height: 3rem;
  margin-bottom: 1rem; /* Space between spinner and text */
`;

const LoadingText = styled.p`
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
`;

const Loader = ({ isLoading, loadingMessage }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <LoaderContainer>
      <StyledSpinner animation="border" variant="light" role="status" />
      <LoadingText>{loadingMessage}</LoadingText>
    </LoaderContainer>
  );
};

export default Loader;

